import { Month, FilterState, FilterType, CalendarEvent } from './common-types';

export const filterTypes: FilterType[] = Object.values(FilterType);

export const applyFilters = (events: Month[] | undefined, filterState: FilterState) => {
    if (!events) return;
    const activeFilters = filterTypes.filter(filterType => {
        const filterAppliedState = filterState[filterType];
        return filterAppliedState.value && filterAppliedState.value.filter(filterValue => filterValue !== "").length > 0;
    });
    if (activeFilters.length == 0) {
        return events;
    }
    const filteredEvents = events.map(month => {
        let monthHasEvents = false;
        const filteredDays = month.days.map(day => {
            const filteredEvents = day.events.filter(event => {
                return activeFilters.some(activeFilter => {
                    let eventTags = event[activeFilter];
                    if (!eventTags) return false;
                    let filterTags = filterState[activeFilter].value;
                    if (typeof (eventTags) == 'string') {
                        eventTags = eventTags ? [eventTags] : [];
                    }
                    let match = eventTags.filter(tag => filterTags.includes(tag));
                    if (match.length > 0) {
                        monthHasEvents = true;
                    }
                    return match.length > 0;
                })
            });
            return {
                ...day,
                events: filteredEvents
            };
        });
        return {
            ...month,
            anyEvents: monthHasEvents,
            days: filteredDays
        }
    });
    return filteredEvents;
}